import React from 'react';
import { CheckIcon, AlertTriangleIcon, XIcon } from 'lucide-react';
import type { BadgeStatus } from '../../types';
interface BadgeProps {
  status: BadgeStatus;
  size?: 'sm' | 'md';
  label?: string;
}
const config: Record<BadgeStatus, {
  bg: string;
  text: string;
  icon: React.ReactNode;
  defaultLabel: string;
}> = {
  'on-track': {
    bg: 'bg-emerald-50 border-emerald-200',
    text: 'text-emerald-700',
    icon: <CheckIcon className="w-3 h-3" data-id="element-296" />,
    defaultLabel: 'On Track'
  },
  'at-risk': {
    bg: 'bg-amber-50 border-amber-200',
    text: 'text-amber-700',
    icon: <AlertTriangleIcon className="w-3 h-3" data-id="element-297" />,
    defaultLabel: 'At Risk'
  },
  behind: {
    bg: 'bg-red-50 border-red-200',
    text: 'text-red-700',
    icon: <XIcon className="w-3 h-3" data-id="element-298" />,
    defaultLabel: 'Behind'
  },
  achieved: {
    bg: 'bg-emerald-50 border-emerald-200',
    text: 'text-emerald-700',
    icon: <CheckIcon className="w-3 h-3" data-id="element-299" />,
    defaultLabel: 'Achieved'
  },
  missed: {
    bg: 'bg-red-50 border-red-200',
    text: 'text-red-700',
    icon: <XIcon className="w-3 h-3" data-id="element-300" />,
    defaultLabel: 'Missed'
  }
};
export function Badge({
  status,
  size = 'sm',
  label
}: BadgeProps) {
  const c = config[status];
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  const padding = size === 'sm' ? 'px-2 py-0.5' : 'px-2.5 py-1';
  return <span className={`inline-flex items-center gap-1 rounded-full border font-medium ${c.bg} ${c.text} ${textSize} ${padding}`} data-id="element-301">
      {c.icon}
      {label || c.defaultLabel}
    </span>;
}